import { Box } from '@mui/material';
import React, { useCallback } from 'react';
import { DemoChatPrompt } from './DemoChatPrompt';
import { AgentType } from '@server/ai';
import { useSelector } from 'react-redux';
import { selectAgents } from '../../components/aiAgentCenter/agentsSelectors';
import { selectDefaultCreationCrmOrgId } from '../../reducers/userInfoReducer';
import useAgentsChats from '../../components/aiAgentCenter/useAgentsChats';
import { AgentChatInstanceProvider } from '../../components/aiAgentCenter/AgentChatInstanceContext';
import useAgentsHome from '../../components/aiAgentCenter/useAgentsHome';
import { ChatInstance } from '../../components/aiAgentCenter/ChatInstance';

interface ChatEntryPointProps {
  onClose: () => void;
}

const ChatEntryPointContent = ({ onClose }: ChatEntryPointProps) => {
  const { onConfirmMessage, setAgentClickHandler } = useAgentsChats();
  const { openAgentsPanel } = useAgentsHome();
  const crmOrgId = useSelector(selectDefaultCreationCrmOrgId);
  const _crmOrgId = crmOrgId ?? undefined;
  const agents = useSelector(selectAgents(_crmOrgId));

  // Find the first Documentation agent
  const documentationAgent = agents?.find((agent) => agent.type === AgentType.Documentation);

  const onSendMessage = useCallback(
    async (messageContent: string) => {
      if (!documentationAgent) {
        console.error('No Documentation agent found');
        return;
      }

      try {
        //TODO add the instance id of the agentsPanel
        onConfirmMessage({
          messageStr: messageContent,
          agentId: documentationAgent.id,
          agentType: documentationAgent.type,
          isFirstMessage: true,
          dontSendToServer: false,
          disableNavigation: true,
        });

        // Set the agent as active for the chat
        setAgentClickHandler({ agent: documentationAgent });
        openAgentsPanel();
        onClose();
      } catch (error) {
        console.error('Failed to send message:', error);
      }
    },
    [documentationAgent, onConfirmMessage, setAgentClickHandler, openAgentsPanel, onClose],
  );

  if (!documentationAgent) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1,
      }}
    >
      <Box
        sx={{
          width: '600px',
          // border: `1px solid ${colors.grey[300]}`,
          backgroundColor: 'transparent',
          boxSizing: 'border-box',
          // borderRadius: '4px',
          padding: 0,
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            right: '0',
            top: '-34px',
          }}
        ></Box>
        <DemoChatPrompt onSendMessage={onSendMessage} />
      </Box>
    </Box>
  );
};

export const DemoChatEntryPoint = ({ onClose }: ChatEntryPointProps) => {
  return (
    <AgentChatInstanceProvider instanceId={ChatInstance.agentsPanel}>
      <ChatEntryPointContent onClose={onClose} />
    </AgentChatInstanceProvider>
  );
};
